<template>
  <article>
    <span style="position: relative">
      <v-layout align-center justify-center row fill-height>
        <h5 style="color:gainsboro;;padding: 20px;">Notas importadas:</h5>
      </v-layout>
      <v-layout row wrap class="infos" style="margin-bottom: 31px;">
        <v-flex class="l_layout" d-flex xs12 sm3 md3 v-for="(card,i) in cards" :key="card.id">
          <v-card class="cardTipos" :class="card.cor">
            <v-layout row wrap>
              <v-flex>
                <div class="c_title" style>{{card.title}}</div>
                <div class="c_title c_sub" style>{{card.subTitle}}</div>
                <div class="values" :id="`value${i}`">{{firstAccess[`${card.id}Qtd`]}}</div>
                <div class="analise">{{card.analise}}</div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </span>
    <div v-if="firstAccess.buscando == false" class="fadeInUp">
        <v-container
    
        fluid
        grid-list-xl
        style="position: absolute;top: 50%;transform: translateY(-50%);"
        >
        
        <v-layout class="beginButton" align-center justify-center row fill-height>
            <span style="text-align: center;position:relative;">
            <h1 style="font-family: monospace;color: #fbfbfb;">
                Bem vindo,
                <strong class="nome_c">{{conta.nome}}</strong>.
            </h1>
            <h2 style="font-family: monospace;color: #fbfbfb;">Motor Fiscal está pronto para uso!</h2>
            <v-btn
                color="white"
                small
                outline
                text-color="white"
                class="bg_white begin_custom"
                @click="begin(), $router.push('/DashBoard')"
            >Começar</v-btn>
            <svg class="custom_anime c_hand_icon" style="width:55px;height:45px" viewBox="0 0 24 24">
                    <path style="fill: white;" d="M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z" />
                </svg>
            </span>
        </v-layout>
        </v-container>
    </div >
  </article>
</template>
<script>
import ContaService from '@/domain/conta/ContaService.js'
export default {
  props: ["firstAccess", "conta", "empresa"],
  data() {
    return {
      cards: [
        {
          id: "nfe",
          title: "NF-e:",
          subTitle: "Nota Fiscal Eletrônica",
          valor: 0,
          cor: "c_primary"
        },
        {
          id: "cte",
          title: "CT-e:",
          subTitle: "Conhecimento de Transporte Eletrônico",
          valor: 0,

          cor: "c_teal"
        },
        {
          id: "nfse",
          title: "NFS-e:",
          subTitle: "Nota Fiscal de Serviço Eletrônica",
          valor: 0,

          cor: "c_little-grey"
        }
      ]
    };
  },
  created() {},
    mounted: function() {
    this.$nextTick(function() {})},
    watch: {
        "firstAccess.buscando": function(newV,oldV){
            if(newV == false){
                 this.begin();
            }
        }
    },
  methods: {
      begin: function(){
          this.service = new ContaService(this.$http);
          this.service.attPrimAcesso(this.conta.conta).then(resp =>{
              if(resp.ok){
                  let auxConta = this.$session.get("jwt");
                  this.conta["accessToken"] = auxConta.accessToken;
                  this.conta.primAcesso = false;
                  this.$session.set("jwt",this.conta);
              }else{
                  throw new Error('Não foi possível iniciar motor fiscal')
              }
          })
      }
  },
};
</script>
<style scoped>
.beginButton {
  height: 100%;
}
.beginButton::before {
    content: "";
    position: absolute;
    width: 25em;
    background-image: url(/static/img/drawing-gears-coloring-page.png);
    background-size: cover;
    background-size: auto;
    background-repeat: round;
    height: 25em;
    opacity: 0.4;
}
#firstRow {
  margin-top: 0px;
}

.cardTipos {
  border-radius: 8px;
  padding: 33px;
  max-width: 284px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  padding-top: 11px;
  z-index: 2;
  border: thin solid white;
}
.cardTipos.c_primary {
  background: linear-gradient(#25476a2e, #01ada6);
}
.cardTipos.c_teal {
  background: linear-gradient(#25476a2e, #4f808a);
}
.cardTipos.c_little-grey {
  background: linear-gradient(#25476a2e, #01ada6);
}
.cardTipos.c_black {
  background: #3c454d !important;
}
.cardTipos .c_icon {
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: 8px;
  font-size: 27px;
}
.cardTipos .values {
  color: white;
  font-size: 19px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
.cardTipos .c_title {
  text-align: center;
  color: white;
  font-weight: 900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
.cardTipos .analise {
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  font-size: 12px;
}
.nome_c {
  font-family: monospace;
  color: #fbfbfb;
  position: relative;
}
.c_hand_icon{
    width: 32px;
    position: absolute;
    bottom: -50px;
    left: 46%;
}
.nome_c::after{
    content: '';
    position: absolute;
    width: 30%;
    height: 3px;
    background: -webkit-gradient(linear, left top, left bottom, from(#25476a2e), to(#01ada6));
    bottom: 0;
    background: linear-gradient(#25476a2e, #00a29b);
    left: 0;
}
.c_sub {
  text-align: left !important;
  color: #ced1d5 !important;
  font-size: 10px;
  position: absolute !important;
  bottom: 4px;
}
.l_layout {
  margin: 0 auto;
}
.beginButton::before {
  animation: loader 7s infinite;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}



@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  animation: fadeInUp 4s ease-in;
}

</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/firstAccess/FirstAccess.vue